import cn from 'bem-cn';

import { List, Stack } from '../../../UI';

import { ChallengeChecklistProps } from './ChallengeChecklist.types';
import { ChallengeChecklistItem } from './ChallengeChecklistItem';
import './ChallengeChecklist.scss';

const b = cn('challenge-checklist');

const renderChecklistItem = (item: string, index: number) => <ChallengeChecklistItem index={index + 1} text={item} />;
const extractTagKey = (_: string, index: number) => `checklist-item-${index}`;

export const ChallengeChecklist = (props: ChallengeChecklistProps) => {
    const { checklist } = props;

    return (
        <Stack spacing={16} className={b()}>
            <h2 className={b('title')}>Что должно быть в заявке</h2>
            <List
                className={b('list')}
                items={checklist}
                renderItem={renderChecklistItem}
                keyExtractor={extractTagKey}
            />
        </Stack>
    );
};
